import url from './url.js'
import axios from './axios.conf.js'
import * as mock from './mock'
import {Toast} from 'mint-ui'

let ISMOCK
ISMOCK = false
// ISMOCK = true

if (window.location.hostname === 'm.jd.jr.com') {
  ISMOCK = false
}
//获取参与并激活列表接口(奖券)
export function initRotaryTable (params) {
  if (ISMOCK) {
    console.warn('initRotaryTable' + ' is mocked.')
    return Promise.resolve(mock.initRotaryTable)
  }

  return axios.post(url.initRotaryTable, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }
    return data
  })
}
//b端总的和已使用的抽奖机会
export function getBTotalAndUsedTimes (params) {
  if (ISMOCK) {
    console.warn('getBTotalAndUsedTimes' + ' is mocked.')
    return Promise.resolve(mock.getBTotalAndUsedTimes)
  }

  return axios.post(url.getBTotalAndUsedTimes, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//b端抽奖
export function bShenQLottery (params) {
  if (ISMOCK) {
    console.warn('bShenQLottery' + ' is mocked.')
    return Promise.resolve(mock.bShenQLottery)
  }

  return axios.post(url.bShenQLottery, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//分享前加密B端pin
export function encodeBpin (params) {
  if (ISMOCK) {
    console.warn('encodeBpin' + ' is mocked.')
    return Promise.resolve(mock.encodeBpin)
  }

  return axios.post(url.encodeBpin, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//c端助力B端
export function cHelpBAndLottery (params) {
  if (ISMOCK) {
    console.warn('cHelpBAndLottery' + ' is mocked.')
    return Promise.resolve(mock.cHelpBAndLottery)
  }

  return axios.post(url.cHelpBAndLottery, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//根据加密pin获取b端头像链接
export function getHeadUrlByEnBPin (params) {
  if (ISMOCK) {
    console.warn('getHeadUrlByEnBPin' + ' is mocked.')
    return Promise.resolve(mock.getHeadUrlByEnBPin)
  }

  return axios.post(url.getHeadUrlByEnBPin, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//查询C端领奖页面信息
export function getToDayHitRd (params) {
  if (ISMOCK) {
    console.warn('getToDayHitRd' + ' is mocked.')
    return Promise.resolve(mock.getToDayHitRd)
  }

  return axios.post(url.getToDayHitRd, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//C端领奖
export function cPickupReward (params) {
  if (ISMOCK) {
    console.warn('cPickupReward' + ' is mocked.')
    return Promise.resolve(mock.cPickupReward)
  }

  return axios.post(url.cPickupReward, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//分享链接
export function fromShareRedirect (params) {
  if (ISMOCK) {
    console.warn('fromShareRedirect' + ' is mocked.')
    return Promise.resolve(mock.fromShareRedirect)
  }

  return axios.post(url.fromShareRedirect, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//最近中奖人及总抽奖人次
export function getLastHitRdListAndTotal (params) {
  if (ISMOCK) {
    console.warn('getLastHitRdListAndTotal' + ' is mocked.')
    return Promise.resolve(mock.getLastHitRdListAndTotal)
  }

  return axios.post(url.getLastHitRdListAndTotal, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}
//保存B端分享记录
export function sQShareSave (params) {
  if (ISMOCK) {
    console.warn('sQShareSave' + ' is mocked.')
    return Promise.resolve(mock.sQShareSave)
  }

  return axios.post(url.sQShareSave, params).then(data => {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    return data
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js